var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import moment from 'moment';
import { mapState } from 'vuex';
import { contractStatus, agreementSignStatus, businessModel, } from '../../enum/common';
import table from '../../components/console-common/table.vue';
import contractView from '../../components/contract/contract-view.vue';
import contractEdit from '../../components/contract/contract-edit.vue';
import commonVideo from '../../components/console-common/common-video.vue';
import repaymentPlan from '../../components/contract/contract-repayment-plan.vue';
import eventBus from '../../utils/fresh-table';
import cookie from '../../cookie/cookie';
export default Vue.extend({
    name: 'login',
    components: {
        'el-contract-list': table,
        'el-contract-view': contractView,
        'el-contract-edit': contractEdit,
        'el-common-video': commonVideo,
        'el-repayment-plan': repaymentPlan,
    },
    computed: __assign({}, mapState('info', ['cityList', 'signCompanyList', 'settleCompanyList']), mapState('user', {
        leftMenuList: 'leftMenuList',
    })),
    data: function () {
        var _this = this;
        var info = this.$store.state.info;
        return {
            opeBtnActive: 'active',
            contractCode: '',
            otherParam: {},
            preFilledParam: {},
            repaymentVisible: false,
            usernameZh: '',
            merchantId: '',
            repaymentImportPermissions: false,
            repaymentViewPermissions: false,
            queryPara: {},
            defaultSearch: {
                inputSearch: 'driverName',
                havePlansFlag: '',
                leaseMode: '',
                repayment: '',
            },
            searchConfig: [
                {
                    type: 'inputSearch',
                    key: 'inputSearch',
                    placeholder: '请输入内容',
                    option: [
                        {
                            label: '司机姓名',
                            val: 'driverName',
                        },
                        {
                            label: '合同号',
                            val: 'contractCode',
                        },
                        {
                            label: '手机号',
                            val: 'driverMobile',
                        },
                    ],
                },
                {
                    label: '车牌号',
                    key: 'plateNumber',
                    type: 'input',
                    placeholder: '请输入车牌号',
                },
                {
                    label: '业务模式',
                    key: 'leaseMode',
                    type: 'radio',
                    option: [
                        {
                            label: '不限',
                            val: '',
                        },
                        {
                            label: '经租',
                            val: 'JINGZU',
                        },
                        {
                            label: '融租',
                            val: 'RONGZU',
                        },
                    ],
                },
                {
                    label: '代扣协议',
                    key: 'signStatus',
                    type: 'select',
                    placeholder: '请选择代扣协议',
                    option: [
                        {
                            label: '不限',
                            val: '',
                        },
                        {
                            label: '未发送',
                            val: 'UNSEND',
                        },
                        {
                            label: '未签署',
                            val: 'UNSIGN',
                        },
                        {
                            label: '已签署',
                            val: 'SIGNED',
                        },
                    ],
                },
                {
                    label: '合同状态',
                    key: 'activeState',
                    type: 'select',
                    placeholder: '请选择合同状态',
                    option: [
                        {
                            label: '不限',
                            val: '',
                        },
                        {
                            label: '未开始',
                            val: 'INACTIVE',
                        },
                        {
                            label: '使用中',
                            val: 'ACTIVE',
                        },
                        {
                            label: '已结束',
                            val: 'TERMINATED',
                        },
                    ],
                },
                {
                    label: '还款计划',
                    key: 'havePlansFlag',
                    type: 'radio',
                    option: [
                        {
                            label: '不限',
                            val: '',
                        },
                        {
                            label: '已创建',
                            val: 'HAVE',
                        },
                        {
                            label: '未创建',
                            val: 'NONE',
                        },
                    ],
                },
                {
                    label: '城市',
                    key: 'cityCode',
                    type: 'select',
                    filterable: true,
                    clearable: true,
                    placeholder: '请选择城市',
                    option: info.cityList,
                },
                {
                    label: '所属公司',
                    key: 'signCompanyName',
                    type: 'select',
                    filterable: true,
                    tooltip: true,
                    clearable: true,
                    placeholder: '请选择所属公司',
                    option: info.signCompanyList,
                },
                {
                    label: '结算公司',
                    key: 'settlementCompanyName',
                    type: 'select',
                    tooltip: true,
                    filterable: true,
                    clearable: true,
                    placeholder: '请选择结算公司',
                    option: info.settleCompanyList,
                },
                {
                    label: '经办人',
                    key: 'transactorContract',
                    tooltip: true,
                    type: 'input',
                    placeholder: '请输入经办人',
                },
                {
                    label: '销售',
                    key: 'transactorSale',
                    tooltip: true,
                    type: 'input',
                    placeholder: '请输入销售',
                },
                {
                    label: '司管',
                    key: 'transactorManager',
                    tooltip: true,
                    type: 'input',
                    placeholder: '请输入司管',
                },
            ],
            exportConfig: {
                fileName: '合同列表',
                keyUrl: '/proxy/api/contract/export',
                statusUrl: '/proxy/api/getFileUrl',
                statusKeys: 'fileGiftKey',
            },
            requestConfig: {
                url: '/proxy/api/contract/page',
                method: 'post',
            },
            tableConfig: [
                {
                    label: '合同号',
                    prop: 'contractCode',
                    tooltip: true,
                    width: '150px',
                    fixed: 'left',
                },
                {
                    label: '合同状态',
                    prop: 'activeState',
                    tooltip: true,
                    width: '100px',
                    formatter: function (val) {
                        return contractStatus[val] || '--';
                    },
                },
                {
                    label: '代扣协议',
                    prop: 'signStatus',
                    width: '100px',
                    tooltip: true,
                    formatter: function (val) {
                        return agreementSignStatus[val] || '--';
                    },
                },
                {
                    label: '司机姓名',
                    prop: 'driverName',
                    tooltip: true,
                    width: '110px',
                },
                {
                    label: '车牌号',
                    prop: 'plateNumber',
                    width: '150px',
                    tooltip: true,
                },
                {
                    label: '合同开始日期',
                    prop: 'startTime',
                    width: '150px',
                    sortable: 'custom',
                    sortableUp: 'START_TIME_ASC',
                    sortableDown: 'START_TIME_DESC',
                    tooltip: true,
                    formatter: function (val) {
                        return val && moment(val).format('YYYY-MM-DD');
                    },
                },
                {
                    label: '合同结束日期',
                    prop: 'endTime',
                    tooltip: true,
                    sortable: 'custom',
                    sortableUp: 'END_TIME_ASC',
                    sortableDown: 'END_TIME_DESC',
                    width: '150px',
                    formatter: function (val) {
                        return val && moment(val).format('YYYY-MM-DD');
                    },
                },
                {
                    label: '注册手机号',
                    prop: 'driverMobile',
                    width: '130px',
                    tooltip: true,
                },
                {
                    label: '身份证号',
                    prop: 'driverIdNo',
                    width: '185px',
                    tooltip: true,
                },
                {
                    label: '联系方式',
                    prop: 'driverContact',
                    tooltip: true,
                    width: '130px',
                },
                {
                    label: '业务模式',
                    prop: 'leaseMode',
                    width: '98px',
                    tooltip: true,
                    formatter: function (val) {
                        return businessModel[val] || '--';
                    },
                },
                {
                    label: '城市',
                    prop: 'cityName',
                    width: '110px',
                    tooltip: true,
                },
                {
                    label: '还款开始日期',
                    prop: 'repayStartTime',
                    sortable: 'custom',
                    sortableUp: 'REPAY_START_TIME_ASC',
                    sortableDown: 'REPAY_START_TIME_DESC',
                    width: '150px',
                    tooltip: true,
                    formatter: function (val) {
                        return val && moment(val).format('YYYY-MM-DD');
                    },
                },
                {
                    label: '还款结束日期',
                    prop: 'repayEndTime',
                    sortable: 'custom',
                    sortableUp: 'REPAY_END_TIME_ASC',
                    sortableDown: 'REPAY_END_TIME_DESC',
                    width: '150px',
                    tooltip: true,
                    formatter: function (val) {
                        return val && moment(val).format('YYYY-MM-DD');
                    },
                },
                {
                    label: '所属公司',
                    prop: 'signCompanyName',
                    tooltip: true,
                    width: '208px',
                },
                {
                    label: '结算公司',
                    prop: 'settlementCompanyName',
                    tooltip: true,
                    width: '208px',
                },
                {
                    label: '合同经办人',
                    prop: 'transactorContract',
                    tooltip: true,
                    width: '113px',
                },
                {
                    label: '司管',
                    prop: 'transactorManager',
                    tooltip: true,
                    width: '83px',
                },
                {
                    label: '销售',
                    prop: 'transactorSale',
                    tooltip: true,
                    width: '83px',
                },
                {
                    label: '操作',
                    prop: 'ope_control_group',
                    width: '260px',
                    fixed: 'right',
                    btns: [
                        {
                            name: '查看',
                            formatter: function (_a) {
                                var activeState = _a.activeState;
                                return /^INACTIVE|ACTIVE|TERMINATED$/.test(activeState);
                            },
                            border: function () {
                                return false;
                            },
                            callback: function (row) {
                                _this.contractView(row);
                            },
                        },
                        {
                            name: '终止',
                            formatter: function (_a) {
                                var activeState = _a.activeState, recordCount = _a.recordCount;
                                return (activeState === 'ACTIVE' ||
                                    (activeState !== 'TERMINATED' && recordCount > 0));
                            },
                            border: function (row) {
                                var tableConfig = _this.tableConfig;
                                var len = tableConfig.length;
                                var btn = tableConfig[len - 1].btns;
                                return btn[0].formatter(row);
                            },
                            callback: function (row) {
                                _this.stop(row);
                            },
                        },
                        {
                            name: '编辑',
                            formatter: function (_a) {
                                var activeState = _a.activeState;
                                return /^INACTIVE|ACTIVE$/.test(activeState);
                            },
                            border: function (row) {
                                var tableConfig = _this.tableConfig;
                                var len = tableConfig.length;
                                var btn = tableConfig[len - 1].btns;
                                return btn[0].formatter(row) || btn[1].formatter(row);
                            },
                            callback: function (row) {
                                _this.contractViewEdit(row);
                            },
                        },
                        {
                            name: '删除',
                            formatter: function (_a) {
                                var activeState = _a.activeState, recordCount = _a.recordCount;
                                return activeState === 'INACTIVE' && recordCount === 0;
                            },
                            border: function (row) {
                                var tableConfig = _this.tableConfig;
                                var len = tableConfig.length;
                                var btn = tableConfig[len - 1].btns;
                                return (btn[0].formatter(row) ||
                                    btn[1].formatter(row) ||
                                    btn[2].formatter(row));
                            },
                            callback: function (row) {
                                _this.deleteC(row);
                            },
                        },
                        {
                            name: '创建还款计划',
                            formatter: function (_a) {
                                var planCount = _a.planCount, status = _a.status;
                                var repaymentImportPermissions = _this.repaymentImportPermissions;
                                return (repaymentImportPermissions &&
                                    status === 'NORMAL' &&
                                    planCount <= 0);
                            },
                            border: function (row) {
                                var tableConfig = _this.tableConfig;
                                var len = tableConfig.length;
                                var btn = tableConfig[len - 1].btns;
                                return (btn[0].formatter(row) ||
                                    btn[1].formatter(row) ||
                                    btn[2].formatter(row) ||
                                    btn[3].formatter(row));
                            },
                            callback: function (_a) {
                                var contractCode = _a.contractCode;
                                _this.$router.push({
                                    name: 'repaymentImport',
                                    params: { contractCode: contractCode },
                                });
                            },
                        },
                        {
                            name: '查看还款计划',
                            formatter: function (_a) {
                                var planCount = _a.planCount, status = _a.status;
                                var _b = _this, repaymentImportPermissions = _b.repaymentImportPermissions, repaymentViewPermissions = _b.repaymentViewPermissions;
                                return (repaymentImportPermissions &&
                                    repaymentViewPermissions &&
                                    status === 'NORMAL' &&
                                    planCount > 0);
                            },
                            border: function (row) {
                                var tableConfig = _this.tableConfig;
                                var len = tableConfig.length;
                                var btn = tableConfig[len - 1].btns;
                                return (btn[0].formatter(row) ||
                                    btn[1].formatter(row) ||
                                    btn[2].formatter(row) ||
                                    btn[3].formatter(row));
                            },
                            callback: function (_a) {
                                var contractCode = _a.contractCode;
                                _this.repaymentVisible = true;
                                _this.contractCode = contractCode;
                            },
                        },
                    ],
                },
            ],
        };
    },
    created: function () {
        this.getUserName();
        this.$store.dispatch('info/GET_COMPANY_ALL', { type: 'SIGN' });
        this.$store.dispatch('info/GET_COMPANY_ALL', { type: 'SETTLEMENT' });
        this.initPreFilledParam();
        this.getPermissions();
    },
    methods: {
        getPermissions: function () {
            var leftMenuList = this.leftMenuList;
            var childMenu = null;
            var repaymentImportPermissions = false;
            var repaymentViewPermissions = false;
            leftMenuList.forEach(function (item) {
                if (item.resourceCode === 'repay_plan') {
                    childMenu = item.children;
                }
            });
            childMenu &&
                childMenu.forEach(function (item) {
                    if (item.resourceCode === 'repay_plan_import') {
                        repaymentImportPermissions = true;
                    }
                    if (item.resourceCode === 'repay_plan_query') {
                        repaymentViewPermissions = true;
                    }
                });
            this.repaymentImportPermissions = repaymentImportPermissions;
            this.repaymentViewPermissions =
                repaymentImportPermissions && repaymentViewPermissions;
        },
        initPreFilledParam: function () {
            var params = this.$route.params;
            for (var item in params) {
                this.preFilledParam[item] = params[item];
                if (item === 'days') {
                    this.opeBtnActive = 'normal';
                }
            }
        },
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
        stop: function (item) {
            var _this = this;
            this.$confirm('', '', {
                message: "<p class=\"title\" style=\"line-height:30px;margin-bottom:75px;word-break:break-all\">\u60A8\u786E\u5B9A\u8981\u7EC8\u6B62\u5408\u540C" + item.contractCode + "\u5417?</p><p class=\"text\" style=\"position:absolute;bottom:75px;padding-right:25px\">\u7EC8\u6B62\u6B64\u5408\u540C\u5C06\u540C\u65F6\u505C\u7528\u76F8\u5E94\u7684\u8FD8\u6B3E\u8BA1\u5212\uFF0C\u65E0\u6CD5\u6062\u590D\u3002\u5DF2\u903E\u671F\u7684\u8FD8\u6B3E\u8BA1\u5212\u4E5F\u5C06\u88AB\u7EC8\u6B62\u3002</p>",
                dangerouslyUseHTMLString: true,
                confirmButtonText: '终止合同',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: 'contract-confirm',
                showClose: false,
            }).then(function () {
                _this.$request({
                    method: 'post',
                    url: '/proxy/api/contract/terminate',
                    data: {
                        contractCode: item.contractCode,
                    },
                }).then(function (res) {
                    if (!res) {
                        return;
                    }
                    if (!res.errorCode) {
                        _this.$message("\u5408\u540C" + item.contractCode + "\u5DF2\u7ED3\u675F");
                        eventBus.$emit('freshTable');
                    }
                });
            });
        },
        contractViewEdit: function (item) {
            var contractCode = item.contractCode;
            this.$store.dispatch('contract/GET_CONTRACTDETAIL', {
                contractCode: contractCode,
                type: 'edit',
            });
        },
        contractView: function (item) {
            var contractCode = item.contractCode;
            this.$store.dispatch('contract/GET_CONTRACTDETAIL', {
                contractCode: contractCode,
                type: 'view',
            });
        },
        deleteC: function (item) {
            var _this = this;
            this.$confirm('', '', {
                message: "<p class=\"title\" style=\"line-height:30px;margin-bottom:50px;word-break:break-all\">\u60A8\u786E\u5B9A\u8981\u5220\u9664\u5408\u540C" + item.contractCode + "\u5417?</p><p class=\"text\" style=\"position:absolute;bottom:75px;padding-right:25px\">\u8BE5\u64CD\u4F5C\u4E0D\u53EF\u9006\u3002</p>",
                dangerouslyUseHTMLString: true,
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                customClass: 'contract-confirm',
                type: 'warning',
                showClose: false,
            }).then(function () {
                _this.$request({
                    method: 'post',
                    url: '/proxy/api/contract/delete',
                    data: {
                        contractCode: item.contractCode,
                        operator: _this.usernameZh,
                    },
                }).then(function (res) {
                    if (!res) {
                        return;
                    }
                    if (!res.errorCode) {
                        _this.$message("\u5220\u9664\u6210\u529F");
                        eventBus.$emit('freshTable');
                    }
                });
            });
        },
        tabOpeBtnActive: function (type) {
            if (type === 'all') {
                this.opeBtnActive = 'active';
                this.otherParam = {
                    days: '',
                };
                return;
            }
            this.opeBtnActive = 'normal';
            this.otherParam = {
                days: 15,
            };
        },
        resetDialog: function () {
            this.repaymentVisible = false;
        },
    },
    watch: {
        cityList: function (val) {
            this.searchConfig[6].option = val;
        },
        signCompanyList: function (val) {
            if (val[0] && val[0].clearSelf === '_NODATA_SIGN') {
                val.splice(0, 1);
            }
            this.searchConfig[7].option = val;
        },
        settleCompanyList: function (val) {
            if (val[0] && val[0].clearSelf === '_NODATA_SETTLEMENT') {
                val.splice(0, 1);
            }
            this.searchConfig[8].option = val;
        },
        leftMenuList: function () {
            this.getPermissions();
        },
    },
});
